import { requestWithPromise } from '..'
import { GET, makeQueryStringFromObject } from '../apiHelper'

export const getAllSectionToYears = (user, parameters = {}) => {
  return requestWithPromise(
    `/api/section-to-years${makeQueryStringFromObject(parameters)}`,
    GET,
    null,
    user
  )
}

export const getBySection = (section, user) => {
  return requestWithPromise(
    `/api/sections/${section.id}/section-to-years`,
    GET,
    null,
    user
  )
}
